module.exports = "build/assets/doubleWhisp.216acd51.png";